<template>
    <section class="preresult-wrap">
        <!-- audio -->
        <audio ref="bg-audio" loop class="bg-audio" preload @canplay="audioCanplay" @pause="audioPause" @ended="audioEnded" @playing="audioPlay" :src="currentAudio"></audio>
        <div class="audio-button" :class="{'pause': !audioPlaying }" @click="toggleAudio"></div>
        <!-- bg -->
        <video ref="bg-video" class="preresult-video-bg" muted preload loop poster="../../assets/images/home/preresult/bg.png" :src="currentBg" @canplaythrough="videoCanplay" @playing="videoPlaying" @pause="videoPause"></video>
        <!-- result -->
        <div class="result-wrap">
            <div class="result-box">
                <img src="../../assets/images/home/preresult/pre_box.png" class="pre_bg" alt="">
                <p class="pre-num">{{ preNumString }}</p>
                <p class="pre-time">2019년 12월 26일 ~ 2020년 1월 2일</p>
                <div class="a-box-content">
                    <a href="https://cafe.naver.com/arknightskor" target="_blank" class="a-box--cafe a-box"></a>
                    <a href="https://www.youtube.com/channel/UCnnbUv4urnbWgb_lgGUfeBw" target="_blank" class="a-box-youtube a-box"></a>
                    <a href="https://twitter.com/ArknightsKorea" target="_blank" class="a-box-twitter a-box"></a>
                    <a href="https://www.facebook.com/ArknightsKorea" target="_blank" class="a-box-facebook a-box"></a>
                </div>
                <router-link to="/prereward" target="_blank" class="to-reward-wrap"></router-link>
            </div>
        </div>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "PreResult",
    components: {

    },
    data: () => ({
        bgList: [
            {
                num: 50000,
                bg: require("../../assets/video/pre/kr_web_5w.mp4"),
                audioUrl: require("../../assets/audio/preresult/4s.mp3")
            },
            {
                num: 100000,
                bg: require("../../assets/video/pre/kr_web_10w.mp4"),
                audioUrl: require("../../assets/audio/preresult/4s.mp3")
            },
            {
                num: 150000,
                bg: require("../../assets/video/pre/kr_web_15w.mp4"),
                audioUrl: require("../../assets/audio/preresult/4s.mp3")
            },
            {
                num: 200000,
                bg: require("../../assets/video/pre/kr_web_20w.mp4"),
                audioUrl: require("../../assets/audio/preresult/5s.mp3")
            },
            {
                num: 250000,
                bg: require("../../assets/video/pre/kr_web_25w.mp4"),
                audioUrl: require("../../assets/audio/preresult/5s.mp3")
            },
            {
                num: 300000,
                bg: require("../../assets/video/pre/kr_web_30w.mp4"),
                audioUrl: require("../../assets/audio/preresult/6s.mp3")
            }
        ],

        audioLoaded: false,
        audioPlaying: true,
        videoLoaded: false,
    }),
    created() {
        if(process.env.VUE_APP_ENV !== 'online' && this.$route.query.num) {
            this.$store.commit('Pre/SET_PRE_NUM', this.$route.query.num)
        }
    },
    mounted() {
        window.addEventListener('resize', this.$utils.debounce(this.resizeVideoSize, this, 50)
        , false)
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val === 3) {
                this.$refs['bg-video'].play()
            } else {
                this.$refs['bg-video'].pause()
            }
        }
    },
    computed: {
        currentBg() {       // 当前背景
            let currentIndex = 0
            for(let i = 0, len = this.bgList.length; i < len; i++) {
                if(this.bgList[i].num <= this.PRE_NUM) {
                    currentIndex = i + 1
                    if(i == len - 1) {
                        currentIndex = i
                    }
                } else {
                    break;
                }
            }
            return this.bgList[currentIndex].bg
        },
        currentAudio() {       // 当前背景
            let currentIndex = 0
            for(let i = 0, len = this.bgList.length; i < len; i++) {
                if(this.bgList[i].num <= this.PRE_NUM) {
                    currentIndex = i + 1
                    if(i == len - 1) {
                        currentIndex = i
                    }
                } else {
                    break;
                }
            }
            return this.bgList[currentIndex].audioUrl
        },
        preNumString() {    // 界面显示预约人数
            return this.PRE_NUM.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        },
        ...mapState({
            PRE_NUM: state => state.Pre.PRE_NUM,        // 当前预约人数
        }),
        ...mapGetters({
            NAV_ACTIVE_INDEX: 'Home/NAV_ACTIVE_INDEX'
        })
    },
    methods: {
        resizeVideoSize() {
            this.$utils.setVideoSize(".preresult-video-bg", ".preresult-wrap")
        },
        videoCanplay() {
            console.log("video canplay")
            this.$utils.setVideoSize(".preresult-video-bg", ".preresult-wrap")
        },
        videoPlaying() {
            if(this.audioLoaded && this.audioPlaying) {
                this.$refs['bg-audio'].play()
            }
        },
        videoPause() {
            console.log("video pause")
            if(this.$refs['bg-audio']) {
                this.$refs['bg-audio'].pause()
            }
        },
        audioCanplay() {
            console.log("audio canplay")
            this.audioLoaded = true
        },
        audioPlay() {
            console.log("audio play")
        },
        audioEnded() {
            console.log("audio ended")
        },
        audioPause() {
            console.log("audio pause")
        },
        toggleAudio() {
            this.audioPlaying = !this.audioPlaying
            if(!this.audioPlaying) {
                this.$refs['bg-audio'].pause()
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.preresult-wrap {
    color: #fff;
    position: relative;
    border-right: none;
    border-left: none;
    background: #000;
    overflow: hidden;
    
    &::before {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background: transparent;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .audio-button {
        position: absolute;
        width: pxTorem(46px);
        height: pxTorem(34px);
        bottom: pxTorem(50px);
        left:  pxTorem(50px);
        background: url("../../assets/images/home/preresult/sound.png") no-repeat;
        background-size: 100%;
        cursor: pointer;
        z-index: 997;

        &.pause {
            background: url("../../assets/images/home/preresult/sound_close.png") no-repeat;
            background-size: 100%;
        }
    }

    .preresult-video-bg {
        position: absolute;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: url("../../assets/images/home/preresult/bg.png") no-repeat;     // video不显示时，显示
        background-size: contain;
        background-position: center center;
        z-index: 1;
    }

    .result-wrap {
        position: absolute;
        right: pxTorem(50px);
        top: 0;
        width: auto;
        height: 100%;
        z-index: 998;
        // background: linear-gradient(to left, rgba(2, 14, 34, 1), rgba(2, 14, 34, 1) 65%, rgba(2, 14, 34, 0));

        .result-box {
            position: relative;
            width: pxTorem(550px);
            top: 50%;
            right: 0px;
            transform: translateY(-50%);

            .pre_bg {
                width: 100%;
            }
            .pre-num {
                position: absolute;
                z-index: 999;
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: 100;
                font-size: pxTorem(60px);
                letter-spacing: pxTorem(-3px);
                color: #fff;
                top: pxTorem(200px);
                right: pxTorem(40px);
            }
            .pre-time {
                position: absolute;
                z-index: 999;
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: 400;
                font-size: pxTorem(32px);
                letter-spacing: pxTorem(-3px);
                color: #fff;
                top: pxTorem(360px);
                right: pxTorem(40px);
            }
            .a-box-content {
                position: absolute;
                z-index: 999;
                width: pxTorem(440px);
                height: pxTorem(80px);
                bottom: pxTorem(182px);
                right: pxTorem(43px);
                display: flex;

                .a-box {
                    display: block;
                    width: pxTorem(235px);
                    height: pxTorem(80px);
                    cursor: pointer;

                    &:not(:last-child) {
                        margin-right: pxTorem(45px);
                    }
                }
            }
            .to-reward-wrap {
                position: absolute;
                z-index: 999;
                display: block;
                width: pxTorem(440px);
                height: pxTorem(40px);
                bottom: pxTorem(30px);
                right: pxTorem(40px);
            }
            .result-tip {
                font-family: 'Noto Sans KR', sans-serif;
                color: #fff;
                font-size: pxTorem(16px);
                font-weight: 700;
                width: 100%;
                box-sizing: border-box;
                padding-left: pxTorem(75px);
                margin-top: pxTorem(20px);
            }
        }
    }
}
</style>
